module.exports = __webpack_public_path__ + "static/media/thermometer-half.533b88f5.svg";